import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CiudadesComponent} from "../../ciudades.component";
import {WeightService} from "../../../../../../core/services/parameters/weight.service";
import {CityService} from "../../../../../../core/services/parameters/city.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-city.component.html',
  styleUrls: ['./confirm-delete-city.component.scss']
})
export class ConfirmDeleteCityComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<CiudadesComponent>,
    private cityService: CityService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {}

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.cityService.deleteCity(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      });
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
